const AdbooksRoutes = {
  getAllAdbooks: "/admin/getallblogs",
  createAdbook: "/blog/blog",
  updateAdbook: "/blog/updateblogs",
  approveBlog: "/admin/approveBlog",
  updateSequence: "/blog/updateBlogSequence",
}

export default AdbooksRoutes;